import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	margin-top: 1rem;
`;

export const Title = styled.h6`
	font-weight: bold;
	color: #000;
	padding: 0rem 0.5rem;
`;

export const ContainerCard = styled.div`
	display: grid;
	width: 100%;
	row-gap: 1rem;

	header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	strong {
		display: block;
		font-size: 0.9rem;
		font-weight: bold;
		line-height: 0.5rem;
	}
`;
interface IContentProps {
	hideColumn?: boolean;
}
export const Content = styled.div<IContentProps>`
	display: grid;
	grid-template-columns: ${({ hideColumn }) =>
		hideColumn ? "50px repeat(5, minmax(100px, 1fr)) 100px 50px" : "50px repeat(6, minmax(100px, 1fr)) 100px 50px"};
	grid-auto-flow: column;
	grid-gap: 1rem;

	background: #fff;
	width: 100%;
	min-width: 960px;
	cursor: pointer;

	padding: 1rem;
	border-radius: 1rem;

	p {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0;
	}

	&:hover {
		background-color: #f1f1f1;
	}
	> div {
		justify-content: center;
	}
`;

export const ContentContainer = styled.div`
	width: 100%;
	overflow: auto;
`;

export const AreaIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	.MuiSvgIcon-root {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const ContentHeader = styled.div`
	display: flex;
	flex-direction: row;

	padding: 1rem 0rem;

	align-items: flex-start;
	justify-content: space-between;
`;

export const ContentBody = styled.div`
	display: flex;
	flex-direction: row;

	align-items: flex-start;
	justify-content: flex-start;
`;

export const ContentCollapse = styled.div`
	padding: 1rem 1.5rem;
	background: ${({ theme }) => theme.white};
`;

export const EndMessage = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0px;
`;

export const TooltipText = styled.p`
	margin: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 100%;
	max-width: 300px;
`;

export const HyperLink = styled.a`
	&&& {
		color: ${({ theme }) => theme.pantone2727C};
		text-decoration: underline;
	}
`;
